import { DispatchWithoutAction } from 'react';
import { useKeyDown } from './useKeyDown';

export function useEscapeKeyDown(close: DispatchWithoutAction) {
  useKeyDown('Escape', close);
}
